import { styled } from "@mui/material/styles";

import { Button, Dialog, Grid, IconButton, lighten, Table } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  marginTop: "15px",
  // flexWrap: "wrap",
});

export const BlockContainer = styled(Grid)({
  display: "flex",
  gap: "15px",
});

export const AvailableLanguageContainer = styled(Grid)({
  display: "flex",
  alignItems: "right",
  gap: "10px",
  // flexDirection: "column",
  "& .MuiInputBase-root": {
    width: "150px",
  },
  marginBottom: "10px",
});

export const SingleLanguageContainer = styled(Grid)({
  display: "flex",
  gap: "5px",
  justifyContent: "space-between",
  "& .MuiButton-root": {
    display: "flex",
    flexDirection: "column",
    width: "110px",
    transition: "all 0.3s ease",
    "& .MuiTypography-root": {
      textTransform: "none",
    },
  },
});

export const DeleteLanguageVersionButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.primary.contrastText,
  // width : "0px",
  // height : "0px",
  // transition : "all 0.3s ease"
}));

export const AddNewLanguageContainer = styled(Grid)({
  display: "flex",
  gap: "10px",
  "& .MuiInputBase-root": {
    borderRadius: "5px",
  },
  "& .MuiAutocomplete-input": {
    width: "110px !important",
    padding: "0px !important",
  },
});

export const ActionsAndDocumentContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  width: "30%",
  // border : `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  // borderRadius : "8px",
  // padding : "15px"
}));

export const DocumentsContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  // width: "30%",
  border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderRadius: "8px",
  padding: "15px",
}));

export const ActionsContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "column",
  gap: "10px",
  // width: "30%",
  border: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
  borderRadius: "8px",
  padding: "15px",
  "& .MuiButton-root": {
    width: "100%",
  },
}));

export const DocumentContainer = styled(Grid)({
  display: "flex",
  gap: "15px",
  alignItems: "center",
  justifyContent: "space-between",
});

export const ReviewersContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
});

export const ReviewersHeaderContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const LogoContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "10px",
  marginLeft: "auto",
});

export const LogoImageContainer = styled(Grid)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const EditReviewerContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  marginTop: "15px",
});

export const ReviewerTable = styled(Table)(({ theme }) => ({
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      backgroundColor: theme.palette.background.paper,
      "&:first-of-type": {
        borderRadius: "8px 0px 0px 0px",
      },
      "&:last-of-type": {
        borderRadius: "0px 8px 0px 0px",
      },
    },
  },
  "& .MuiTableBody-root": {
    "& .MuiTableRow-root": {
      "& .MuiTableCell-root:not(:last-of-type)": {
        borderRight: `1px solid ${lighten(theme.palette.secondary.light, 0.5)}`,
      },
    },
  },
}));
export const DocumentViewerContainer = styled(Dialog)({
  overflow: "hidden",
  "& .MuiPaper-root": {
    maxWidth: "fit-content",
  },
});
